import React from 'react'
import {Svg} from '@modifi/ui'

export default ({...props}) => (
  <Svg viewBox="0 0 150 150" {...props}>
    <g fill="none" fillRule="evenodd">
      <g stroke="#51565C">
        <path
          strokeWidth="3.5"
          d="M116.273 61.21C110.751 43.699 94.36 31 75 31c-23.894 0-43.263 19.341-43.263 43.2 0 .556.01 1.109.031 1.659"
        />
        <path
          fill="#51565C"
          fillRule="nonzero"
          d="M31.538 76.094l9.355-7.264 1.165 1.483-10.026 7.785a.95.95 0 0 1-1.262-.088l-8.844-9.105 1.36-1.307 8.252 8.496z"
        />
        <path
          strokeWidth="3.5"
          d="M34.218 89.918c5.955 16.75 21.966 28.744 40.782 28.744 23.894 0 43.263-19.341 43.263-43.2 0-.556-.01-1.109-.031-1.659"
        />
        <path
          fill="#51565C"
          fillRule="nonzero"
          d="M118.462 73.568l-9.355 7.264-1.165-1.483 10.026-7.785a.95.95 0 0 1 1.262.088l8.844 9.105-1.36 1.307-8.252-8.496z"
        />
      </g>
      <path fill="#7BB835" d="M53.4 48.686h22.105V70.76H53.4z" />
      <path
        fill="#FFF"
        d="M68.684 61.963c0 .69-.252 1.28-.758 1.772-.505.492-1.233.797-2.185.915v1.412h-1.263v-1.375a6.882 6.882 0 0 1-1.781-.328c-.564-.185-1.02-.412-1.364-.68l.694-1.54c.32.236.695.434 1.125.593.43.16.871.261 1.326.303V60.93a9.539 9.539 0 0 1-1.516-.48 2.673 2.673 0 0 1-1.036-.775c-.278-.34-.417-.793-.417-1.356 0-.698.255-1.297.765-1.798.51-.5 1.244-.805 2.204-.914v-1.4h1.263v1.375c1.036.084 1.89.34 2.564.77l-.631 1.55a5.028 5.028 0 0 0-1.933-.655v2.144c.59.134 1.088.288 1.497.46.408.173.751.43 1.03.77.277.34.416.788.416 1.343zm-5.14-3.746c0 .21.08.382.24.517.16.135.39.248.694.34v-1.79c-.32.075-.556.195-.707.359a.819.819 0 0 0-.228.574zm2.197 4.768c.303-.068.53-.177.682-.328a.74.74 0 0 0 .228-.543.652.652 0 0 0-.234-.517c-.156-.134-.381-.252-.676-.353v1.74z"
      />
      <path fill="#53A2D9" d="M81.048 65.078h22.105v22.074H81.048z" />
      <path
        fill="#FFF"
        d="M93.414 79.352c.885 0 1.63-.35 2.236-1.047l1.301 1.21a4.105 4.105 0 0 1-1.56 1.174c-.619.269-1.311.403-2.078.403-.732 0-1.412-.13-2.04-.39a4.44 4.44 0 0 1-1.598-1.11 4.314 4.314 0 0 1-.947-1.666h-1.427v-1.06h1.238a3.358 3.358 0 0 1-.013-.34c0-.151.004-.265.013-.34H87.3v-1.06h1.427c.194-.63.51-1.186.947-1.665.438-.48.97-.85 1.598-1.11a5.264 5.264 0 0 1 2.04-.39c.767 0 1.46.134 2.078.403.62.269 1.14.656 1.56 1.16l-1.3 1.211c-.616-.69-1.36-1.034-2.237-1.034-.555 0-1.052.126-1.49.378a2.575 2.575 0 0 0-1.01 1.047h3.195v1.06h-3.512c-.008.075-.012.189-.012.34 0 .152.004.265.012.34h3.512v1.06h-3.196c.236.446.573.795 1.01 1.047.439.252.936.379 1.491.379z"
      />
      <g>
        <path fill="#15539F" d="M53.4 77.157h22.105V99.23H53.4z" />
        <path
          fill="#FFF"
          d="M63.935 91.38h4.332v1.64h-7.654v-1.64h1.263v-1.375h-1.263v-1.06h1.263v-.68h-1.263v-1.06H61.9c.093-1.001.495-1.779 1.206-2.334.712-.555 1.67-.832 2.874-.832 1.01 0 1.857.193 2.539.58l-.619 1.614c-.505-.302-1.137-.454-1.895-.454-.59 0-1.057.12-1.402.36s-.556.595-.631 1.066h2.993v1.06h-3.031v.68h3.031v1.06h-3.031v1.375z"
        />
      </g>
    </g>
  </Svg>
)
